"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorCircleStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  padding-top: 100%;\n  display: block;\n  border-radius: 100%;\n  ", "\n\n  ", ", img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 100%;\n    object-fit: cover;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        padding-top: calc(100% - 2px);\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: #", ";\n    ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var white = 'ffffff';

var getCircleStyles = function getCircleStyles(hexValue) {
  var hexStr = hexValue.replace(/^#/, '');
  return (0, _uiKit.css)(_templateObject(), hexStr, hexStr.toLocaleLowerCase() === white && (0, _uiKit.css)(_templateObject2(), _uiKit.Colors.gray300));
};

var ColorCircleStyled = (0, _uiKit.styled)('span')(_templateObject3(), function (_ref) {
  var hexValue = _ref.hexValue;
  return hexValue && getCircleStyles(hexValue);
}, _uiKit.LoadingBlockStyled);
exports.ColorCircleStyled = ColorCircleStyled;